var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { delay } from "../../helpers";
export class TokenStream {
    constructor(requestService, tokenHandler, tokenReader, errorHandler) {
        this.requestService = requestService;
        this.tokenHandler = tokenHandler;
        this.tokenReader = tokenReader;
        this.errorHandler = errorHandler;
    }
    run(firstToken, cancellation) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.getTokensStream(firstToken, cancellation);
            }
            catch (e) {
                this.errorHandler.handleError(e);
            }
        });
    }
    getTokensStream(firstToken, cancellation) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = firstToken;
            while (!cancellation.isCancelled) {
                this.tokenHandler.onTokenChanged(token);
                const renewInterval = this.tokenReader.getIntervalForRenew(token);
                yield delay(renewInterval);
                if (!cancellation.isCancelled) {
                    token = yield this.requestService.getRenewedToken(token);
                }
            }
        });
    }
}
//# sourceMappingURL=TokenStream.js.map